// import React, { useState } from "react";
// import {
//   Typography,
//   Box,
//   useTheme,
//   alpha,
//   Grid,
//   Card,
//   CardContent,
//   CardMedia,
//   Button,
//   Chip,
//   TextField,
//   InputAdornment,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   Rating,
//   LinearProgress,
//   Tabs,
//   Tab,
//   Avatar,
//   Paper,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import PlayCircleIcon from "@mui/icons-material/PlayCircle";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import PaymentIcon from "@mui/icons-material/Payment";
// import PeopleIcon from "@mui/icons-material/People";
// import HomeIcon from "@mui/icons-material/Home";
// import WarningIcon from "@mui/icons-material/Warning";
// import CloseIcon from "@mui/icons-material/Close";
// import ThumbUpIcon from "@mui/icons-material/ThumbUp";
// import ThumbDownIcon from "@mui/icons-material/ThumbDown";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import SupportLayout from "./SupportLayout";

// const VideoTutorials = () => {
//   const theme = useTheme();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedVideo, setSelectedVideo] = useState(null);
//   const [activeCategory, setActiveCategory] = useState(0);

//   const categories = [
//     "All Videos",
//     "Getting Started",
//     "Scheduling",
//     "Payments",
//     "Cleaners",
//     "Properties",
//     "Emergency"
//   ];

//   const videos = [
//     {
//       id: 1,
//       title: "Getting Started as a Host - Full Walkthrough",
//       description: "Complete guide to setting up your host account, adding properties, and creating your first schedule.",
//       duration: "15:32",
//       views: "12.5k views",
//       category: "Getting Started",
//       thumbnail: "/videos/thumbnails/getting-started.jpg",
//       videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
//       rating: 4.8,
//       uploadedAt: "2 weeks ago",
//       instructor: "Sarah Johnson",
//       instructorRole: "Host Success Manager"
//     },
//     {
//       id: 2,
//       title: "How to Create & Manage Cleaning Schedules",
//       description: "Learn how to create one-time and recurring schedules, set preferences, and manage bookings.",
//       duration: "12:15",
//       views: "8.2k views",
//       category: "Scheduling",
//       thumbnail: "/videos/thumbnails/scheduling.jpg",
//       videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
//       rating: 4.9,
//       uploadedAt: "1 month ago",
//       instructor: "Mike Chen",
//       instructorRole: "Product Specialist"
//     },
//     {
//       id: 3,
//       title: "Understanding Payment & Billing System",
//       description: "Detailed explanation of how payments work, invoice generation, and refund policies.",
//       duration: "10:45",
//       views: "6.8k views",
//       category: "Payments",
//       thumbnail: "/videos/thumbnails/payments.jpg",
//       videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
//       rating: 4.7,
//       uploadedAt: "3 weeks ago",
//       instructor: "Emily Rodriguez",
//       instructorRole: "Finance Manager"
//     },
//     {
//       id: 4,
//       title: "Finding and Managing Cleaners",
//       description: "Tips for finding the best cleaners, reviewing their profiles, and building long-term relationships.",
//       duration: "18:22",
//       views: "15.3k views",
//       category: "Cleaners",
//       thumbnail: "/videos/thumbnails/cleaners.jpg",
//       videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
//       rating: 4.9,
//       uploadedAt: "1 week ago",
//       instructor: "David Kim",
//       instructorRole: "Operations Director"
//     },
//     {
//       id: 5,
//       title: "Property Management Best Practices",
//       description: "How to optimize your property listings, add photos, and provide clear instructions.",
//       duration: "14:08",
//       views: "5.4k views",
//       category: "Properties",
//       thumbnail: "/videos/thumbnails/properties.jpg",
//       videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
//       rating: 4.6,
//       uploadedAt: "2 months ago",
//       instructor: "Lisa Wong",
//       instructorRole: "Host Success Coach"
//     },
//     {
//       id: 6,
//       title: "Emergency Protocols & Problem Resolution",
//       description: "What to do when things go wrong: cancellations, damage reports, and dispute resolution.",
//       duration: "11:54",
//       views: "3.9k views",
//       category: "Emergency",
//       thumbnail: "/videos/thumbnails/emergency.jpg",
//       videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
//       rating: 4.8,
//       uploadedAt: "3 days ago",
//       instructor: "Alex Thompson",
//       instructorRole: "Support Team Lead"
//     },
//     {
//       id: 7,
//       title: "Advanced Scheduling Features",
//       description: "Master recurring schedules, calendar integration, and smart notifications.",
//       duration: "09:47",
//       views: "2.1k views",
//       category: "Scheduling",
//       thumbnail: "/videos/thumbnails/advanced-scheduling.jpg",
//       videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
//       rating: 4.5,
//       uploadedAt: "5 days ago",
//       instructor: "Mike Chen",
//       instructorRole: "Product Specialist"
//     },
//     {
//       id: 8,
//       title: "Maximizing Your Host Ratings",
//       description: "Strategies to get 5-star reviews and build a stellar reputation.",
//       duration: "13:21",
//       views: "7.8k views",
//       category: "Getting Started",
//       thumbnail: "/videos/thumbnails/ratings.jpg",
//       videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
//       rating: 4.9,
//       uploadedAt: "2 weeks ago",
//       instructor: "Sarah Johnson",
//       instructorRole: "Host Success Manager"
//     }
//   ];

//   const filteredVideos = videos.filter(video => {
//     const matchesSearch = video.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                          video.description.toLowerCase().includes(searchQuery.toLowerCase());
//     const matchesCategory = activeCategory === 0 || video.category === categories[activeCategory];
//     return matchesSearch && matchesCategory;
//   });

//   const handleVideoClick = (video) => {
//     setSelectedVideo(video);
//   };

//   const handleCloseVideo = () => {
//     setSelectedVideo(null);
//   };

//   return (
//     <SupportLayout
//       title="Video Tutorials"
//       category="Learning Center"
//       subtitle="Watch step-by-step video guides to master every feature"
//       breadcrumbs={[
//         { label: "Help Center", link: "/help" },
//         { label: "Video Tutorials" }
//       ]}
//       stats={[
//         { value: "15+", label: "Video Tutorials" },
//         { value: "5k+", label: "Monthly Views" },
//         { value: "4.8", label: "Average Rating" },
//         { value: "24/7", label: "Access" }
//       ]}
//     >
//       {/* Search Bar */}
//       <TextField
//         fullWidth
//         placeholder="Search video tutorials..."
//         value={searchQuery}
//         onChange={(e) => setSearchQuery(e.target.value)}
//         sx={{ mb: 4 }}
//         InputProps={{
//           startAdornment: (
//             <InputAdornment position="start">
//               <SearchIcon />
//             </InputAdornment>
//           ),
//           sx: { borderRadius: 3 }
//         }}
//       />

//       {/* Category Tabs */}
//       <Tabs
//         value={activeCategory}
//         onChange={(e, val) => setActiveCategory(val)}
//         sx={{ mb: 4, borderBottom: 1, borderColor: 'divider' }}
//         variant="scrollable"
//         scrollButtons="auto"
//       >
//         {categories.map((category, idx) => (
//           <Tab key={idx} label={category} />
//         ))}
//       </Tabs>

//       {/* Videos Grid */}
//       {filteredVideos.length > 0 ? (
//         <Grid container spacing={3}>
//           {filteredVideos.map((video) => (
//             <Grid item xs={12} sm={6} md={4} key={video.id}>
//               <Card 
//                 sx={{ 
//                   height: '100%', 
//                   display: 'flex', 
//                   flexDirection: 'column',
//                   cursor: 'pointer',
//                   transition: 'transform 0.2s',
//                   '&:hover': {
//                     transform: 'translateY(-4px)',
//                     boxShadow: theme.shadows[8]
//                   }
//                 }}
//                 onClick={() => handleVideoClick(video)}
//               >
//                 <Box sx={{ position: 'relative' }}>
//                   <CardMedia
//                     component="img"
//                     height="180"
//                     image={video.thumbnail || "https://via.placeholder.com/300x180?text=Video+Thumbnail"}
//                     alt={video.title}
//                   />
//                   <Box 
//                     sx={{ 
//                       position: 'absolute', 
//                       bottom: 8, 
//                       right: 8,
//                       bgcolor: 'rgba(0,0,0,0.7)',
//                       px: 1,
//                       py: 0.5,
//                       borderRadius: 1,
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 0.5
//                     }}
//                   >
//                     <AccessTimeIcon sx={{ fontSize: 14, color: 'white' }} />
//                     <Typography variant="caption" sx={{ color: 'white' }}>
//                       {video.duration}
//                     </Typography>
//                   </Box>
//                   <Box 
//                     sx={{ 
//                       position: 'absolute', 
//                       top: '50%', 
//                       left: '50%', 
//                       transform: 'translate(-50%, -50%)',
//                       opacity: 0.8,
//                       transition: 'opacity 0.2s',
//                       '&:hover': { opacity: 1 }
//                     }}
//                   >
//                     <PlayCircleIcon sx={{ fontSize: 60, color: 'white' }} />
//                   </Box>
//                 </Box>
                
//                 <CardContent sx={{ flex: 1 }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
//                     <Chip 
//                       label={video.category} 
//                       size="small"
//                       sx={{ 
//                         bgcolor: alpha(theme.palette.primary.main, 0.1),
//                         color: theme.palette.primary.main
//                       }}
//                     />
//                     <Rating value={video.rating} size="small" readOnly precision={0.5} />
//                   </Box>
                  
//                   <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, fontSize: '1.1rem' }}>
//                     {video.title}
//                   </Typography>
                  
//                   <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                     {video.description}
//                   </Typography>
                  
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 'auto' }}>
//                     <Avatar sx={{ width: 24, height: 24, bgcolor: theme.palette.primary.main }}>
//                       {video.instructor.charAt(0)}
//                     </Avatar>
//                     <Box>
//                       <Typography variant="caption" sx={{ fontWeight: 600 }}>
//                         {video.instructor}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary" display="block">
//                         {video.views} • {video.uploadedAt}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
//       ) : (
//         <Box sx={{ textAlign: 'center', py: 8 }}>
//           <PlayCircleIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
//           <Typography variant="h6">No videos found</Typography>
//           <Typography variant="body2" color="text.secondary">
//             Try different search terms or browse by category
//           </Typography>
//         </Box>
//       )}

//       {/* Video Player Dialog */}
//       <Dialog
//         open={!!selectedVideo}
//         onClose={handleCloseVideo}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: { borderRadius: 3, bgcolor: 'black' }
//         }}
//       >
//         {selectedVideo && (
//           <>
//             <DialogTitle sx={{ pb: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <Typography variant="h6" sx={{ color: 'white' }}>
//                 {selectedVideo.title}
//               </Typography>
//               <IconButton onClick={handleCloseVideo} sx={{ color: 'white' }}>
//                 <CloseIcon />
//               </IconButton>
//             </DialogTitle>
//             <DialogContent>
//               <Box sx={{ position: 'relative', paddingBottom: '56.25%', height: 0, mb: 2 }}>
//                 <iframe
//                   src={selectedVideo.videoUrl}
//                   style={{
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     width: '100%',
//                     height: '100%',
//                     borderRadius: 12
//                   }}
//                   frameBorder="0"
//                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                   allowFullScreen
//                 />
//               </Box>
              
//               <Paper sx={{ p: 2, bgcolor: alpha(theme.palette.common.white, 0.1) }}>
//                 <Typography variant="body2" sx={{ color: 'white', mb: 2 }}>
//                   {selectedVideo.description}
//                 </Typography>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
//                       Was this helpful?
//                     </Typography>
//                     <IconButton size="small" sx={{ color: 'white' }}>
//                       <ThumbUpIcon fontSize="small" />
//                     </IconButton>
//                     <IconButton size="small" sx={{ color: 'white' }}>
//                       <ThumbDownIcon fontSize="small" />
//                     </IconButton>
//                   </Box>
//                   <Button 
//                     variant="outlined" 
//                     size="small" 
//                     sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.3)' }}
//                   >
//                     Related Videos
//                   </Button>
//                 </Box>
//               </Paper>
//             </DialogContent>
//           </>
//         )}
//       </Dialog>
//     </SupportLayout>
//   );
// };

// export default VideoTutorials;




import React, { useState } from "react";
import {
  Typography,
  Box,
  useTheme,
  alpha,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Chip,
  TextField,
  InputAdornment,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Rating,
  LinearProgress,
  Tabs,
  Tab,
  Avatar,
  Paper,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PaymentIcon from "@mui/icons-material/Payment";
import PeopleIcon from "@mui/icons-material/People";
import HomeIcon from "@mui/icons-material/Home";
import WarningIcon from "@mui/icons-material/Warning";
import CloseIcon from "@mui/icons-material/Close";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SupportLayout from "./SupportLayout";

const VideoTutorials = () => {
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [activeCategory, setActiveCategory] = useState(0);

  const categories = [
    "All Videos",
    "Getting Started",
    "Scheduling",
    "Payments",
    "Cleaners",
    "Properties",
    "Emergency"
  ];

  const videos = [
    {
      id: 1,
      title: "Getting Started as a Host - Full Walkthrough",
      description: "Complete guide to setting up your host account, adding properties, and creating your first schedule.",
      duration: "15:32",
      views: "12.5k views",
      category: "Getting Started",
      thumbnail: "https://img.youtube.com/vi/9GorqroigqM/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/9GorqroigqM",
      youtubeId: "9GorqroigqM",
      rating: 4.8,
      uploadedAt: "2 weeks ago",
      instructor: "Sarah Johnson",
      instructorRole: "Host Success Manager"
    },
    {
      id: 2,
      title: "How to Create & Manage Cleaning Schedules",
      description: "Learn how to create one-time and recurring schedules, set preferences, and manage bookings efficiently.",
      duration: "12:15",
      views: "8.2k views",
      category: "Scheduling",
      thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      youtubeId: "dQw4w9WgXcQ",
      rating: 4.9,
      uploadedAt: "1 month ago",
      instructor: "Mike Chen",
      instructorRole: "Product Specialist"
    },
    {
      id: 3,
      title: "Understanding Payment & Billing System",
      description: "Detailed explanation of how payments work, invoice generation, and refund policies for hosts.",
      duration: "10:45",
      views: "6.8k views",
      category: "Payments",
      thumbnail: "https://img.youtube.com/vi/4TAtRCJNt2U/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/4TAtRCJNt2U",
      youtubeId: "4TAtRCJNt2U",
      rating: 4.7,
      uploadedAt: "3 weeks ago",
      instructor: "Emily Rodriguez",
      instructorRole: "Finance Manager"
    },
    {
      id: 4,
      title: "Finding and Managing Cleaners",
      description: "Tips for finding the best cleaners, reviewing their profiles, and building long-term professional relationships.",
      duration: "18:22",
      views: "15.3k views",
      category: "Cleaners",
      thumbnail: "https://img.youtube.com/vi/5wCwJXjqG5Y/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/5wCwJXjqG5Y",
      youtubeId: "5wCwJXjqG5Y",
      rating: 4.9,
      uploadedAt: "1 week ago",
      instructor: "David Kim",
      instructorRole: "Operations Director"
    },
    {
      id: 5,
      title: "Property Management Best Practices",
      description: "How to optimize your property listings, add professional photos, and provide clear access instructions.",
      duration: "14:08",
      views: "5.4k views",
      category: "Properties",
      thumbnail: "https://img.youtube.com/vi/7VbF2yG8HBQ/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/7VbF2yG8HBQ",
      youtubeId: "7VbF2yG8HBQ",
      rating: 4.6,
      uploadedAt: "2 months ago",
      instructor: "Lisa Wong",
      instructorRole: "Host Success Coach"
    },
    {
      id: 6,
      title: "Emergency Protocols & Problem Resolution",
      description: "What to do when things go wrong: cancellations, damage reports, and dispute resolution processes.",
      duration: "11:54",
      views: "3.9k views",
      category: "Emergency",
      thumbnail: "https://img.youtube.com/vi/8XjY8PqXqH0/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/8XjY8PqXqH0",
      youtubeId: "8XjY8PqXqH0",
      rating: 4.8,
      uploadedAt: "3 days ago",
      instructor: "Alex Thompson",
      instructorRole: "Support Team Lead"
    },
    {
      id: 7,
      title: "Advanced Scheduling Features",
      description: "Master recurring schedules, calendar integration, smart notifications, and automation tools.",
      duration: "09:47",
      views: "2.1k views",
      category: "Scheduling",
      thumbnail: "https://img.youtube.com/vi/2zNSgSzhBfM/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/2zNSgSzhBfM",
      youtubeId: "2zNSgSzhBfM",
      rating: 4.5,
      uploadedAt: "5 days ago",
      instructor: "Mike Chen",
      instructorRole: "Product Specialist"
    },
    {
      id: 8,
      title: "Maximizing Your Host Ratings",
      description: "Strategies to get 5-star reviews, handle feedback, and build a stellar reputation on the platform.",
      duration: "13:21",
      views: "7.8k views",
      category: "Getting Started",
      thumbnail: "https://img.youtube.com/vi/6YQ9qXjY3Vc/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/6YQ9qXjY3Vc",
      youtubeId: "6YQ9qXjY3Vc",
      rating: 4.9,
      uploadedAt: "2 weeks ago",
      instructor: "Sarah Johnson",
      instructorRole: "Host Success Manager"
    },
    {
      id: 9,
      title: "Deep Cleaning vs Standard Cleaning",
      description: "Understanding the difference between service types and when to recommend each to your property owners.",
      duration: "08:34",
      views: "4.2k views",
      category: "Properties",
      thumbnail: "https://img.youtube.com/vi/3JWTaaS7LdU/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/3JWTaaS7LdU",
      youtubeId: "3JWTaaS7LdU",
      rating: 4.7,
      uploadedAt: "1 week ago",
      instructor: "Lisa Wong",
      instructorRole: "Host Success Coach"
    },
    {
      id: 10,
      title: "Handling Difficult Customer Situations",
      description: "Professional techniques for managing complaints, negotiating solutions, and maintaining positive relationships.",
      duration: "16:42",
      views: "3.1k views",
      category: "Emergency",
      thumbnail: "https://img.youtube.com/vi/9XjY1LqX8Yc/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/9XjY1LqX8Yc",
      youtubeId: "9XjY1LqX8Yc",
      rating: 4.6,
      uploadedAt: "4 days ago",
      instructor: "Alex Thompson",
      instructorRole: "Support Team Lead"
    },
    {
      id: 11,
      title: "Payment Processing & Stripe Integration",
      description: "Step-by-step guide to setting up Stripe, managing payouts, and understanding transaction fees.",
      duration: "11:23",
      views: "5.6k views",
      category: "Payments",
      thumbnail: "https://img.youtube.com/vi/1YqXjG9V8Hc/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/1YqXjG9V8Hc",
      youtubeId: "1YqXjG9V8Hc",
      rating: 4.8,
      uploadedAt: "2 weeks ago",
      instructor: "Emily Rodriguez",
      instructorRole: "Finance Manager"
    },
    {
      id: 12,
      title: "Building a Team of Reliable Cleaners",
      description: "How to recruit, train, and retain high-quality cleaning professionals for your properties.",
      duration: "14:15",
      views: "9.3k views",
      category: "Cleaners",
      thumbnail: "https://img.youtube.com/vi/4WXjY8HqL8U/maxresdefault.jpg",
      videoUrl: "https://www.youtube.com/embed/4WXjY8HqL8U",
      youtubeId: "4WXjY8HqL8U",
      rating: 4.9,
      uploadedAt: "3 days ago",
      instructor: "David Kim",
      instructorRole: "Operations Director"
    }
  ];

  // Collection of alternative placeholder videos (if needed)
  const placeholderPlaylists = [
    {
      name: "Cleaning Business Tips",
      playlistId: "PLrAXtmEmZ2-RH6yT2f8Q9XjY8HqL8U4W",
      description: "Complete guide to running a successful cleaning business"
    },
    {
      name: "Property Management",
      playlistId: "PLrAXtmEmZ2-SH6yT2f8Q9XjY8HqL8U4W",
      description: "Best practices for managing rental properties"
    }
  ];

  const getYouTubeThumbnail = (youtubeId) => {
    return `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`;
  };

  const filteredVideos = videos.filter(video => {
    const matchesSearch = video.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         video.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = activeCategory === 0 || video.category === categories[activeCategory];
    return matchesSearch && matchesCategory;
  });

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
  };

  const handleCloseVideo = () => {
    setSelectedVideo(null);
  };

  return (
    <SupportLayout
      title="Video Tutorials"
      category="Learning Center"
      subtitle="Watch step-by-step video guides to master every feature"
      breadcrumbs={[
        { label: "Help Center", link: "/help" },
        { label: "Video Tutorials" }
      ]}
      stats={[
        { value: "15+", label: "Video Tutorials" },
        { value: "5k+", label: "Monthly Views" },
        { value: "4.8", label: "Average Rating" },
        { value: "24/7", label: "Access" }
      ]}
    >
      {/* Search Bar */}
      <TextField
        fullWidth
        placeholder="Search video tutorials..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={{ mb: 4 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          sx: { borderRadius: 3 }
        }}
      />

      {/* Category Tabs */}
      <Tabs
        value={activeCategory}
        onChange={(e, val) => setActiveCategory(val)}
        sx={{ mb: 4, borderBottom: 1, borderColor: 'divider' }}
        variant="scrollable"
        scrollButtons="auto"
      >
        {categories.map((category, idx) => (
          <Tab key={idx} label={category} />
        ))}
      </Tabs>

      {/* Videos Grid */}
      {filteredVideos.length > 0 ? (
        <Grid container spacing={3}>
          {filteredVideos.map((video) => (
            <Grid item xs={12} sm={6} md={4} key={video.id}>
              <Card 
                sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8]
                  }
                }}
                onClick={() => handleVideoClick(video)}
              >
                <Box sx={{ position: 'relative' }}>
                  <CardMedia
                    component="img"
                    height="180"
                    image={getYouTubeThumbnail(video.youtubeId)}
                    alt={video.title}
                    sx={{ 
                      objectFit: 'cover',
                      backgroundColor: '#000'
                    }}
                    onError={(e) => {
                      // Fallback if maxresdefault doesn't exist
                      e.target.src = `https://img.youtube.com/vi/${video.youtubeId}/hqdefault.jpg`;
                    }}
                  />
                  <Box 
                    sx={{ 
                      position: 'absolute', 
                      bottom: 8, 
                      right: 8,
                      bgcolor: 'rgba(0,0,0,0.75)',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5
                    }}
                  >
                    <AccessTimeIcon sx={{ fontSize: 14, color: 'white' }} />
                    <Typography variant="caption" sx={{ color: 'white' }}>
                      {video.duration}
                    </Typography>
                  </Box>
                  <Box 
                    sx={{ 
                      position: 'absolute', 
                      top: '50%', 
                      left: '50%', 
                      transform: 'translate(-50%, -50%)',
                      opacity: 0.85,
                      transition: 'opacity 0.2s',
                      '&:hover': { opacity: 1 }
                    }}
                  >
                    <PlayCircleIcon sx={{ fontSize: 64, color: 'white', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }} />
                  </Box>
                </Box>
                
                <CardContent sx={{ flex: 1 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                    <Chip 
                      label={video.category} 
                      size="small"
                      sx={{ 
                        bgcolor: alpha(theme.palette.primary.main, 0.1),
                        color: theme.palette.primary.main
                      }}
                    />
                    <Rating value={video.rating} size="small" readOnly precision={0.5} />
                  </Box>
                  
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, fontSize: '1rem', lineHeight: 1.3 }}>
                    {video.title}
                  </Typography>
                  
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontSize: '0.875rem' }}>
                    {video.description.length > 100 ? `${video.description.substring(0, 100)}...` : video.description}
                  </Typography>
                  
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 'auto' }}>
                    <Avatar sx={{ width: 28, height: 28, bgcolor: theme.palette.primary.main, fontSize: '0.875rem' }}>
                      {video.instructor.charAt(0)}
                    </Avatar>
                    <Box>
                      <Typography variant="caption" sx={{ fontWeight: 600, fontSize: '0.75rem' }}>
                        {video.instructor}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ fontSize: '0.7rem' }}>
                        {video.views} • {video.uploadedAt}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <PlayCircleIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
          <Typography variant="h6">No videos found</Typography>
          <Typography variant="body2" color="text.secondary">
            Try different search terms or browse by category
          </Typography>
        </Box>
      )}

      {/* Video Player Dialog */}
      <Dialog
        open={!!selectedVideo}
        onClose={handleCloseVideo}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { 
            borderRadius: 3, 
            bgcolor: '#000',
            maxWidth: '900px',
            margin: '16px auto'
          }
        }}
      >
        {selectedVideo && (
          <>
            <DialogTitle sx={{ pb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6" sx={{ color: 'white', fontSize: '1.1rem' }}>
                {selectedVideo.title}
              </Typography>
              <IconButton onClick={handleCloseVideo} sx={{ color: 'white' }}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 0 }}>
              <Box sx={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                <iframe
                  src={`${selectedVideo.videoUrl}?autoplay=1&rel=0&modestbranding=1`}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                  }}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title={selectedVideo.title}
                />
              </Box>
              
              <Paper sx={{ p: 2, bgcolor: alpha(theme.palette.common.white, 0.05), borderRadius: 0 }}>
                <Typography variant="body2" sx={{ color: 'white', mb: 2 }}>
                  {selectedVideo.description}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                      Was this helpful?
                    </Typography>
                    <IconButton size="small" sx={{ color: 'white' }}>
                      <ThumbUpIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" sx={{ color: 'white' }}>
                      <ThumbDownIcon fontSize="small" />
                    </IconButton>
                  </Box>
                  <Button 
                    variant="outlined" 
                    size="small" 
                    sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.3)' }}
                    href={`https://www.youtube.com/watch?v=${selectedVideo.youtubeId}`}
                    target="_blank"
                  >
                    Watch on YouTube
                  </Button>
                </Box>
              </Paper>
            </DialogContent>
          </>
        )}
      </Dialog>
    </SupportLayout>
  );
};

export default VideoTutorials;